// extracted by mini-css-extract-plugin
export var table = "_yn-0";